

 const Fetcher = async ({varible,dispatch}) => {
    try{
      //https://estoredata.onrender.com
     const response = await  fetch('https://estoredata.onrender.com'+varible)
     if(!response.ok){
     throw new Error(`HTTP Error ${response.status}`)
     }
      const responsedata = await response.json()
         dispatch({ type:'sucess',payload :responsedata})
}
catch(err){
  
  dispatch({ type:'error',errormessage :err.message})
   
    
}}

export const poducturl = ({id , dispatch})=>{
 let varible  = '/products?catId='+id 
 Fetcher({  varible,dispatch})
  
}

export const categoriesurl = ({dispatch})=>{
  let varible = '/categories'
  
  Fetcher({  varible,dispatch})
}
export const productdetails = ({Productid,dispatch})=>{
  let varible = '/products/'+Productid
  Fetcher({ varible,dispatch})
}

export const searchbyquery  =({query,dispatch})=>{
  let varible = '/products?q='+query

  Fetcher({ varible,dispatch})
}

export const Sliderdetails = ({dispatch,count})=>{ 
  let varible = '/Slider/'+count

Fetcher({ varible,dispatch})

}
export const BestSelling = ({dispatch})=>{
  let varible = '/BestSelling'

  Fetcher({ varible,dispatch})

}

export const Homeproduction = ({dispatch})=>{
  let varible = '/products'

  Fetcher({ varible,dispatch})

}